let navigate: any = null;

export const setNavigate = (navFn: any) => {
  navigate = navFn;
};

export const navigateTo = (path: any, options = {}) => {
  if (navigate) {
    navigate(path, options);
  } else {
    return;
  }
};
